import React from "react";
import { observer } from "mobx-react";
import { Paper, Typography } from "../../../../common/components/libs";
import { Coupon, CouponData, CouponType } from "../../../../services/coupons/models";
import { convertDate } from "../../../../common/libs";
import IconButton from "@material-ui/core/IconButton";
import { Delete as DeleteIcon, Edit as EditIcon } from "@material-ui/icons";
import { CouponsFormType } from "../../store/forms";
import {Trans, useTranslation} from "react-i18next";
import { useStores } from "../../../../hooks";

interface CouponCardProps {
    coupon: Coupon;
    delete: (id: number) => void;
    edit: (data: CouponData, couponId: number) => void;
    showForm: (type: CouponsFormType, coupon: Coupon) => void;
    usages: number
}

const CouponCard = (props: CouponCardProps) => {
    const { generalStore } = useStores();
    const locale = generalStore.locale.id
    const {coupon} = props;
    const {i18n, t} = useTranslation(["general", "coupons"]);


    return (
        <Paper p={5} style={{ maxWidth: 400, width: "100%" }}>
            <Typography variant={"h6"} style={{ marginTop: 20 }}>
                {t("coupons:coupon")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5 }}>
                {coupon.data.code}
            </Typography>
            <Typography variant={"h6"} style={{ marginTop: 20 }}>
                {t("coupons:discount")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5 }}>
                {coupon.data.type === CouponType.percentage? coupon.data.discountPercent + '%':  coupon.data.discountAmount.amount + generalStore.currency.currencyShortName[locale]}
            </Typography>
            <Typography variant={"h6"} style={{ marginTop: 20 }}>
                {t("coupons:numberOfUses")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5 }}>
                {props.usages}/{coupon.data.totalUsagesLimit}
            </Typography>
            <Typography variant={"h6"} style={{ marginTop: 20 }}>
                {t("coupons:validity")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5 }}>
                {convertDate(coupon.data.startDate)} – {convertDate(coupon.data.endDate)}
            </Typography>
            <Typography variant={"h6"} style={{ marginTop: 20 }}>
                {t("general:actions")}
            </Typography>
            <Typography variant={"body1"} style={{ marginTop: 5 }}>
                <IconButton aria-label="delete"
                            onClick={() => props.showForm(CouponsFormType.createCoupon, coupon)}>
                    <EditIcon/>
                </IconButton>
                <IconButton aria-label="delete"
                            onClick={() => {props.delete(coupon.id)}}>
                    <DeleteIcon/>
                </IconButton>
            </Typography>
        </Paper>
    );
};

export default observer(CouponCard);
